// BigBlob shader: mixes gradient with multiple blurred dye dots (procedural positions)
const frag = `
precision mediump float;

uniform vec2 u_resolution;
uniform float u_time;
uniform float u_speed;
uniform float u_seed;

uniform vec3 u_color_0;
uniform vec3 u_color_1;
uniform vec3 u_color_2;
uniform vec3 u_color_3;
uniform vec3 u_color_4;
uniform vec3 u_color_5;

uniform float u_magnitude; // wobble magnitude
uniform float u_inner;     // inner radius
uniform float u_outer;     // outer radius

vec4 blurDot(vec3 color, vec2 st, vec2 pos, float inner, float outer) {
    float pct = distance(st, pos);
    float alpha = 1.0 - smoothstep(inner, outer, pct);
    return vec4(color, alpha);
}

void main(){
    vec2 st = gl_FragCoord.xy / u_resolution;
    vec3 color = vec3(1.0);

    // base horizontal gradient similar to BigBlobBg
    color = mix(u_color_0, u_color_1, st.x);
    color = mix(color, u_color_2, st.x * st.x - 0.04);

    // procedural dye centers around a circle, animated by time and seed
    float t = (u_time * u_speed) * 0.5 + u_seed * 0.013;
    float mag = u_magnitude;
    float inner = u_inner;
    float outer = u_outer;

    vec2 p0 = 0.5 + vec2( cos(t + 0.0), sin(t + 0.0)) * mag;
    vec2 p1 = 0.5 + vec2( cos(t + 1.0), sin(t + 1.0)) * mag;
    vec2 p2 = 0.5 + vec2( cos(t + 2.0), sin(t + 2.0)) * mag;
    vec2 p3 = 0.5 + vec2( cos(t + 3.0), sin(t + 3.0)) * mag;
    vec2 p4 = 0.5 + vec2( cos(t + 4.0), sin(t + 4.0)) * mag;
    vec2 p5 = 0.5 + vec2( cos(t + 5.0), sin(t + 5.0)) * mag;

    vec4 d0 = blurDot(u_color_0, st, p0, inner, outer);
    vec4 d1 = blurDot(u_color_1, st, p1, inner, outer);
    vec4 d2 = blurDot(u_color_2, st, p2, inner, outer);
    vec4 d3 = blurDot(u_color_3, st, p3, inner, outer);
    vec4 d4 = blurDot(u_color_4, st, p4, inner, outer);
    vec4 d5 = blurDot(u_color_5, st, p5, inner, outer);

    color = mix(color, d0.rgb, d0.a);
    color = mix(color, d1.rgb, d1.a);
    color = mix(color, d2.rgb, d2.a);
    color = mix(color, d3.rgb, d3.a);
    color = mix(color, d4.rgb, d4.a);
    color = mix(color, d5.rgb, d5.a);

    gl_FragColor = vec4(color, 1.0);
}
`;

const shader = {
  name: 'BigBlob',
  shader: { frag },
  schema: [
    {
      key: 'colors',
      type: 'color-palette',
      label: 'Colors',
      min: 3,
      max: 6,
      default: ['#26292b', '#2a2e35', '#00f2fe', '#4facfe', '#fd6585', '#ffd3a5'],
    },
    {
      key: 'u_magnitude',
      type: 'number',
      label: 'Magnitude',
      min: 0.0,
      max: 0.6,
      step: 0.01,
      default: 0.25,
    },
    {
      key: 'u_inner',
      type: 'number',
      label: 'Inner',
      min: 0.0,
      max: 0.5,
      step: 0.005,
      default: 0.1,
    },
    {
      key: 'u_outer',
      type: 'number',
      label: 'Outer',
      min: 0.05,
      max: 1.0,
      step: 0.005,
      default: 0.7,
    },
    { key: 'u_speed', type: 'number', label: 'Speed', min: 0, max: 10, step: 0.1, default: 1 },
    { key: 'animated', type: 'boolean', label: 'Animated', default: false },
  ],
  examples: [
    'dynamic-shader(BigBlob, colors=#26292b,#2a2e35,#00f2fe,#4facfe,#fd6585,#ffd3a5; u_magnitude=0.25; animated=false)',
    'dynamic-shader(BigBlob, colors=#111,#222,#4facfe,#00f2fe; u_magnitude=0.3; u_inner=0.12; u_outer=0.75)',
  ],
};

export default shader;
